
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState } from 'vuex'
import { getToken } from '@/utils/auth'
import { initDisplayPrefs } from '@/utils/displayPrefs'
import 'vant/lib/index.css'

const TAB_PATHS = ['/home', '/practice', '/wordIndex', '/mine']
const TAB_ROUTES = ['/home', '/practice', '/wordIndex', '/mine']

export default {
directives: {
TransferDom
},
components: {
ViewBox,
Loading,
Actionsheet
},

created () {
initDisplayPrefs()
this.checkLogin()
const ua = navigator.userAgent.toLowerCase()
if (ua.match(/micromessenger/i) || /mobile|android|ios/.test(ua)) {
const viewportMeta = document.querySelector('meta[name="viewport"]')
if (viewportMeta) {
viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
} else {
const meta = document.createElement('meta')
meta.name = 'viewport'
meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
document.head.appendChild(meta)
}
if (!document.querySelector('meta[name="x5-page-mode"]')) {
const x5Meta = document.createElement('meta')
x5Meta.name = 'x5-page-mode'
x5Meta.content = 'default'
document.head.appendChild(x5Meta)
}
}
},

methods: {
checkLogin () {
if (!getToken()) {
this.$router.push({ path: '/sysLogin_display' })
}
},
changeLocale (locale) {
this.$i18n.set(locale)
this.$locale.set(locale)
},
setTabIndexByPath (path) {
const idx = TAB_ROUTES.findIndex(p => path === p || path.startsWith(p + '/'))
if (idx >= 0) this.tabIndex = idx
},
onTabChange (index) {
const path = TAB_ROUTES[index]
if (path && this.route.path !== path) {
this.$router.push({ path, query: { hideTrans: 'true' } })
}
},
initBrowserNavGuard () {


if (typeof window === 'undefined' || !window.history || !window.history.pushState) return
const pushTabTrap = () => {
try {
window.history.pushState({ appTabTrap: true }, '', window.location.href)
} catch (e) { /* ignore */ }
}
this._popstateHandler = () => {
this.$nextTick(() => {
if (TAB_PATHS.includes(this.path)) {
pushTabTrap()
}
})
}
window.addEventListener('popstate', this._popstateHandler)
this.$nextTick(() => {
if (TAB_PATHS.includes(this.path)) {
pushTabTrap()
}
})
}
},

mounted () {
if (!document.querySelector('meta[name="x5-fullscreen"]')) {
const x5Meta = document.createElement('meta')
x5Meta.name = 'x5-fullscreen'
x5Meta.content = 'true'
document.head.appendChild(x5Meta)
}
this.initBrowserNavGuard()

this.$nextTick(() => {
this.setTabIndexByPath(this.path)
})
},

beforeDestroy () {
if (this._popstateHandler) {
window.removeEventListener('popstate', this._popstateHandler)
}
},

watch: {
'route.path' (newPath) {
this.$nextTick(() => {
this.setTabIndexByPath(newPath)
})
if (newPath === '/mine') {
this.showMessage = false
}
}
},

computed: {
...mapState({
route: state => state.route,
path: state => state.route.path,
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction
}),
isShowBar () {
return TAB_PATHS.includes(this.route.path)
},
tabBarPadding () {
return 'calc(50px + env(safe-area-inset-bottom, 0px))'
},
viewTransition () {
if (this.route.fullPath.includes('hideTrans')) {
return ''
}
if (!this.direction) return ''
return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
}
},

data () {
return {
showMenu: false,
tabIndex: 2,
menus: {
'language.noop': '<span class="menu-title">Language</span>',
'zh-CN': '中文',
'en': 'English'
},
showMessage: false
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue